import { Entity } from "./Entity";
import { BaseApiModel } from "./common/BaseApiModel";

export enum PackageSize {
  XS = 'xs',
  S = 's',
  M = 'm',
  L = 'l',
  XL = 'xl',
}

export enum AppRequestStatus {
  OPEN = 'open',
  ACCEPTED = 'accepted',
  IN_PROGRESS = 'in_progress',
  DELIVERED = 'delivered',
  CANCELLED = 'cancelled',
  EXPIRED = 'expired',
}

export enum AppRequestOfferStatus {
  PENDING = 'pending',
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
}

export interface AppRequestOffer {
  id: number;
  request_id: number;
  driver_entity_id: number;
  price_offered: number;
  driver_notes?: string;
  status: AppRequestOfferStatus;
  decision_at?: string;
  created_at: string;
  updated_at: string;
  driverEntity?: {
    id: number;
    name: string;
    surname: string;
    email: string;
    rating_avg: number;
    business_name?: string;
  };
}

export interface AppRequestReview {
  id: number;
  request_id: number;
  reviewer_entity_id: number;
  reviewed_entity_id: number;
  rating: number;
  comment?: string;
  created_at: string;
  updated_at: string;
  reviewerEntity?: {
    id: number;
    name: string;
    surname: string;
    business_name?: string;
  };
  reviewedEntity?: {
    id: number;
    name: string;
    surname: string;
    business_name?: string;
  };
}

export class AppRequest extends BaseApiModel {
  entity_id?: number;
  entity?: Entity;
  assigned_driver_entity_id?: number;
  assignedDriverEntity?: Entity;
  
  // Pickup fields
  pickup_province?: string;
  pickup_city?: string;
  pickup_zipcode?: string;
  pickup_address?: string;
  pickup_lat?: number;
  pickup_lng?: number;
  pickup_name?: string;
  pickup_phone?: string;
  pickup_notes?: string;
  
  // Delivery fields
  delivery_province?: string;
  delivery_city?: string;
  delivery_zipcode?: string;
  delivery_address?: string;
  delivery_lat?: number;
  delivery_lng?: number;
  delivery_name?: string;
  delivery_phone?: string;
  delivery_notes?: string;
  
  billing_info?: any;
  package_size?: PackageSize;
  max_pickup_datetime?: Date;
  max_delivery_datetime?: Date;
  price_offered?: number;
  status?: AppRequestStatus;
  offers_count?: number;
  
  // QR codes
  qr_pickup_code?: string;
  qr_delivery_code?: string;
  
  // Review flags
  customer_reviewed?: boolean;
  driver_reviewed?: boolean;
  
  // Relations
  offers?: AppRequestOffer[];
  driverOffer?: AppRequestOffer;
  reviews?: AppRequestReview[];
}
